<template>
  <div class="dft-title_text">
    <h4 class="dft-header">图文导航</h4>
    <div class="attr-item-box" v-for="(item,index) in value.attrsort" :key="index">
      <div class="attr-item-typedata" v-if="item == 'a1'">
        <!-- <div class="attr-item-label">{{ value.attr[item].label }}</div> -->
        <div class="attr-item-value">
          <div class="addImgList" v-if="value.attr['a2'].value == '1'">
            <div class="imgList_box">
              <draggable
                tag="div"
                class="cardDrag-list-wrap comp-list"
                v-model="value.attr[item].value"
                :group="groupRight"
                animation="100"
                delay="10"
                :sort="true"
              >
                <div class="attr-list-item comp-item" v-for="(iitem,iiIndex) in value.attr[item].value" :key="iitem.id">
                  <el-image
                    style="width: 50px; height: 50px"
                    :src="iitem.logo"
                    :preview-src-list="[iitem.logo]"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div class="goodsinfo">
                    {{`${iitem.categoryName}`}}
                  </div>
                  <i class="el-icon-delete icon_btn" title="删除" @click="mDelete(value.attr[item].value,iiIndex)"></i>
                </div>
              </draggable>
            </div>
            <div class="upload_btn" @click="addClass(value.attr[item].value)" style="margin-top: 8px;">
              <i class="el-icon-plus"></i>
              选择分类
            </div>
            <addClassPage
              ref="addClassPage"
              v-model="value.attr[item].value"
              :showDialog="showClassDialog"
              @goBack="goBack"
            ></addClassPage>
          </div>
          <div class="addImgList" v-else>
            <div class="img_info">建议最多添加 10 个导航，可对其排序。</div>
            <div class="imgList_box">
              <div class="imgList-item" v-for="(ii,iiIndex) in value.attr[item].value" :key="iiIndex"
                >
                <div class="ii-img-box" v-if="value.attr['a2'].value == '2'">
                  <el-image v-if="ii.logo" class="ii-img" :src="ii.logo" fit="scale-down"></el-image>
                  <div class="ii-img-btn">
                    <el-upload
                      class="avatar-uploader-d"
                      :action="$uploadURL"
                      :show-file-list="false"
                      :on-success="(res, file)=>{handleChangeUploadSuccess(res, file,ii,iiIndex)}"
                      :before-upload="beforeUpload"
                    >
                      <div class="">
                        更换图片
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="ii-link-box">
                  <div class="ii-link-btn">
                    <i class="el-icon-top icon_btn" title="上移" v-if="iiIndex != 0" @click="moveUp(value.attr[item].value,iiIndex)"></i>
                    <i class="el-icon-bottom icon_btn" title="下移" v-if="iiIndex != (value.attr[item].value.length - 1)" @click="moveDown(value.attr[item].value,iiIndex)"></i>
                    <i class="el-icon-delete icon_btn" title="删除" @click="mDelete(value.attr[item].value,iiIndex)"></i>
                  </div>
                  <div class="ii-link-info" style="margin-top: 8px;">标题</div>
                  <div class="ii-link">
                    <el-input v-model="ii.categoryName" @blur="updataclassName(ii,ii.categoryName)"></el-input>
                  </div>
                  <!-- <div class="ii-link-info">链接设置</div>
                  <div class="ii-link">
                    <el-input v-model="ii.link"></el-input>
                  </div> -->
                </div>
              </div>
            </div>
            <!-- <el-upload
              class="avatar-uploader-d"
              v-if="value.attr[item].value.length<10"
              :multiple="false"
              :action="$uploadURL"
              :show-file-list="false"
              :on-success="(res, file)=>{handleUploadSuccess(res, file,value.attr[item])}"
              :before-upload="beforeUpload"
            >
              <div class="upload_btn">
                <i class="el-icon-plus" ></i>
                添加图片
              </div>
            </el-upload> -->
          </div>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a2'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" @change="resetClass(value.attr['a1'].value)" size="small">
            <el-radio-button label="1">默认金刚区</el-radio-button>
            <el-radio-button label="2">图片导航</el-radio-button>
            <el-radio-button label="3">文字导航</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a3'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">固定</el-radio-button>
            <el-radio-button label="2">横向滑动</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a11'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">方形</el-radio-button>
            <el-radio-button label="2">圆形</el-radio-button>
            <el-radio-button label="3">圆角</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="item == 'a6'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="0">直角</el-radio-button>
            <el-radio-button label="8px">圆角</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle " v-else-if="item == 'a7'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="0">无边</el-radio-button>
            <el-radio-button label="6px">有边</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="['a8','a9','a10'].includes(item)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-slider v-model="value.attr[item].value" :min="value.attr[item].min" :max="value.attr[item].max"
            show-input :show-input-controls="false" class="custon_slider" input-size="mini"></el-slider>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="['a4','a5'].includes(item)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
        <div class="attr-item-value">
          <div class="colorPicker">
            <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
            <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import addClassPage from '../addClassPage.vue'
export default {
  components: {
    draggable,
    addClassPage
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return { attr: {}, attrsort: [] }
      }
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      showClassDialog: false,
      groupRight: {
        name: 'itxst2',
        pull: false, // 拖出
        put: false // 拖入
      },
      // 模板默认数据
      assemblyAttr666: JSON.stringify(
        {
          attr: {
            a1: {
              label: '图文导航',
              value: [],
              sid: 'attr_s1',
              key: 'text',
              type: 'data',
              tag: 'input'
            },
            a2: {
              label: '选择模板',
              value: '1',
              sid: 'attr_s3',
              showList: {
                '1': '默认金刚区',
                '2': '图片导航',
                '3': '文字导航'
              },
              key: 'mode',
              type: 'data',
              tag: 'radio'
            },
            a3: {
              label: '图片样式',
              value: '1',
              sid: 'attr_s3',
              showList: {
                '1': '固定',
                '2': '横向滑动'
              },
              key: 'logo-background',
              type: 'style',
              tag: 'radio'
            },
            a4: {
              label: '背景颜色',
              value: '#ffffff',
              sid: 'attr_s',
              showList: {},
              default: '#ffffff',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a9: {
              label: '文字大小',
              value: 12,
              sid: 'attr_s',
              min: 8,
              max: 18,
              key: 'font-size',
              type: 'style',
              tag: 'el-slider'
            },
            a5: {
              label: '文字颜色',
              value: '#000000',
              sid: 'attr_s',
              showList: {},
              default: '#000000',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a10: {
              label: '图片尺寸',
              value: 60,
              sid: 'attr_s',
              min: 30,
              max: 75,
              key: 'img-size',
              type: 'style',
              tag: 'el-slider'
            },
            a11: {
              label: '图片形状',
              value: '1',
              sid: 'attr_s3',
              showList: {
                '1': '方形',
                '2': '圆形',
                '3': '圆角'
              },
              key: 'border-radius',
              type: 'style',
              tag: 'radio'
            },
            a6: {
              label: '卡片倒角',
              value: '8px',
              sid: 'attr_s3',
              showList: {
                '0': '直角',
                '8px': '圆角'
              },
              key: 'border-radius',
              type: 'style',
              tag: 'radio'
            },
            a7: {
              label: '上下边距',
              value: '6px',
              sid: 'attr_s3',
              showList: {
                '0': '无边',
                '6px': '有边'
              },
              key: 'logo-background',
              type: 'style',
              tag: 'radio'
            },
            a8: {
              label: '页面边距',
              value: 16,
              sid: 'attr_s5',
              min: 0,
              max: 30,
              key: 'padding',
              type: 'style',
              tag: 'el-slider'
            }
          },
          attrsort: [
            'a2', 'a1', 'a3', 'a4', 'a9', 'a5', 'a10', 'a11', 'a6', 'a7', 'a8'
          ]
        }
      )
    }
  },
  watch: {
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });

    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {

  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    },
    // 配置事件
    // 图片上传成功处理
    handleUploadSuccess (res, file, item) {
      const _imgUrl = file.response.data.url
      item.value.push(
        {
          logo: _imgUrl,
          categoryName: '',
          link: '',
          url: '',
          type: ''
        }
      )
    },
    // 修改图片上传成功处理
    handleChangeUploadSuccess (res, file, ii, iiIndex) {
      const _imgUrl = file.response.data.url
      ii.logo = _imgUrl
      this.updataclassImage(ii, _imgUrl)
    },
    updataclassImage (ii, _imgUrl) {
      console.log(ii, _imgUrl, 'productCategory/update')
      this.$confirm('确认同步更改商品分类的数据并保存分类配置吗?').then(() => {
        var that = this
        const _data = {
          id: ii.id,
          logo: ii.logo
        }
        that.$http.post('/productCategory/update', _data).then(res => {
          if (res.data.code == 200) {
            this.$emit('updateRd', true)
          }
        })
      })
    },
    updataclassName (ii, categoryName) {
      this.$confirm('确认同步更改商品分类的标题并保存分类配置吗?').then(() => {
        var that = this
        const _data = {
          id: ii.id,
          categoryName: categoryName
        }
        that.$http.post('/productCategory/update', _data).then(res => {
          if (res.data.code == 200) {
            this.$emit('updateRd', true)
          }
        })
      })
    },
    // 图片上传之前处理
    beforeUpload (file) {
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return  isLt2M;
    },
    // 上移
    moveUp (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex - 1, 1, value[iiIndex])[0]
    },
    // 下移
    moveDown (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex + 1, 1, value[iiIndex])[0]
    },
    // 删除
    mDelete (value, iiIndex) {
      value.splice(iiIndex, 1)
    },
    addClass (list) {
      this.showClassDialog = true
    },
    resetClass (valuelist) {
      // valuelist.splice(-1)
    },
    goBack (val) {
      // console.log('l;l;',val)
      this.showDialog = false
      this.showClassDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-title_text{
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}
.dft-header{
  margin: 5px 0;
}
.attr-item-box{
  padding: 6px 10px;
  margin-bottom: 10px;
  .attr-item-typedata{
    .attr-item-label{
      margin-bottom: 5px;
    }
    .img_info{
      color: #969799;
      font-weight: 400;
      margin-top: 8px;
      white-space: pre-wrap;
      font-size: 13px;
    }
    .attr-item-value{
      .temp-box{
        display: flex;
        flex-wrap: wrap;
        .temp-item{
          width: calc((100% - 40px)/4);
          height: 90px;
          margin: 0 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .temp-item-img{
            width: 48px;
            height: 48px;
            margin-bottom: 8px;
          }
          .temp-item-name{
            font-weight: 400;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
            color: #333;
          }
        }
        .active_temp-item{
          .temp-item-name{
            color: #155bd4;
          }
        }
      }
      .addImgList{
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .img_info{
          color: #969799;
          font-weight: 400;
          margin-top: 8px;
          white-space: pre-wrap;
          font-size: 13px;
        }
        .imgList_box{
          // padding: 12px 0;
          width: 100%;
          box-sizing: border-box;
          .imgList-item{
            border: 1px solid #e0e0e0;
            margin: 12px 0;
            padding: 4px;
            box-sizing: border-box;
            display: flex;
            .ii-img-box{
              width: 80px;
              height: 100px;
              position: relative;
              flex-shrink: 0;
              .ii-img{
                width: 100%;
                height: 100%;
              }
              .ii-img-btn{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 20px;
                background-color: rgba($color: #000000, $alpha: .5);
                text-align: center;
                font-size: 13px;
                color: #ffffff;
                cursor: pointer;
              }
            }
            .ii-link-box{
              // width: calc(100% - 80px);
              flex: 1;
              box-sizing: border-box;
              height: 100px;
              padding: 0 8px;
              display: flex;
              flex-direction: column;
              position: relative;
              .ii-link-btn{
                position: absolute;
                top: -4px;
                right: 0;
                display: flex;
                justify-content: flex-end;
                font-size: 18px;
                color: #969696;
                .icon_btn{
                  padding: 2px;
                  cursor: pointer;
                  margin: 4px;
                }
              }
              .ii-link-info{
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #999;
              }
              .ii-link{
                /deep/.el-input__inner{
                  height: 24px!important;
                }
              }
            }
          }
          .comp-item{
            width: calc(100% - 12px);
            margin: 8px 6px;
            padding: 6px 10px 6px 14px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 2px;
            display: flex;
            align-items: center;
            border-radius: 2px;
            background-color: #fff;
            box-shadow: 0 0 4px 0 rgba(10, 42, 97, .2);
            .goodsinfo{
              padding-left: 8px;
              font-size: 13px;
            }
            cursor: grab;
            position: relative;
            .icon_btn{
              position: absolute;
              top: 8px;
              right: 16px;
              font-size: 16px;
              cursor: pointer;
              display: none;
            }
            &:hover{
              .icon_btn{
                display: block;
              }
            }
          }
        }

        .upload_btn{
          background: #efefef;
          border-radius: 2px;
          padding: 6px 10px 6px 14px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          margin: 0 auto;
          color: #333;
          cursor: pointer;
        }
      }
    }
  }
  .attr-item-typestyle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    .attr-item-label{
      color: #969799;
      margin-right: 12px;
    }
    .attr-item-on{
      color: #333333;
      margin-right: 8px;
      font-size: 12px;
    }
    .attr-item-value{
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

}

.resetBtn{
  font-size: 13px;
  color: #356fd4;
}
.colorPicker{
  height: 40px;
  display: flex;
  align-items: center;
}
.custon_slider{
  width: 100%;
  /deep/.el-slider__input{
    width: 60px;
  }
  /deep/.el-slider__runway.show-input{
    margin-left: 8px;
    margin-right: 80px;
  }
}
// 说明注释
.info-setby{
  position: relative;
  padding-bottom: 12px;
}
.info-set{
  position: absolute;
  bottom: 0;
  left: 0;
  color: #969799;
  font-size: 12px;
}
</style>
